// Based on http://github.com/asvd/dragscroll (MIT license)

const DragScrollDirective = {
  bind(el, binding, vnode) {
    let lastClientX, lastClientY, pushed;
    let moved = 0;
    const container = el.container || el;
    const scroller = el.scroller || el;

    container.addEventListener(
      'mousedown',
      (container.onMouseDown = function(e) {
        pushed = 1;
        lastClientX = e.clientX;
        lastClientY = e.clientY;

        e.preventDefault();
      }),
    );

    window.addEventListener(
      'mouseup',
      (container.onMouseUp = function(e) {
        pushed = 0;
      }),
    );

    window.addEventListener(
      'mousemove',
      (container.onMouseMove = function(e) {
        if (pushed) {
          const newScrollX = -lastClientX + (lastClientX = e.clientX);
          const newScrollY = -lastClientY + (lastClientY = e.clientY);

          moved += Math.abs(newScrollX) + Math.abs(newScrollY);

          scroller.scrollLeft -= newScrollX;
          scroller.scrollTop -= newScrollY;
        }
      }),
    );

    window.addEventListener(
      'click',
      (container.onClick = function(e) {
        if (moved > 10) {
          e.stopPropagation();
          e.preventDefault();
        }
        moved = 0;
      }),
      { capture: true },
    );
  },

  unbind(el, binding, vnode) {
    const container = el.container || el;

    container.removeEventListener('mousedown', container.onMouseDown);
    window.removeEventListener('mouseup', container.onMouseUp);
    window.removeEventListener('mousemove', container.onMouseMove);
    window.removeEventListener('click', container.onClick);
  },
};

export default DragScrollDirective;
